// extracted by mini-css-extract-plugin
export default {"wrapper":"LegalDocViewer_wrapper__k0B7O","embededPdf":"LegalDocViewer_embededPdf__kZl64"};